<template lang="pug">
aside.follow-modal
  .follow-modal__close(@click='closeModal')
  .follow-modal__container
    h5.follow-modal__title フォローありがとうございました！
    p.follow-modal__message フォローしたことをFacebookにシェアして、企業を応援しませんか？
    section.follow-modal__share
      p.follow-modal__share-company {{ companyName }}
      div.follow-modal__share-buttons
        a.base-button.follow-cancel-button.js-cancel-share(@click='closeModal') キャンセル
        a.base-button.js-cancel-share(@click='onShareLink')
          span シェア
</template>
<style>
.follow-cancel-button {
  margin-right: 8px;
  padding: 5px 20px;
}
</style>
<script>
export default {
  name: 'ShareCompany',
  props: {
    companyIdProps: {
      type: Number,
      default: () => 0
    },
    companyNameProps: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    companyId: {
      get () {
        return this.companyIdProps;
      },
      set (newValue) {
        this.$emit('update:companyIdProps', newValue);
      }
    },
    companyName: {
      get () {
        return this.companyNameProps;
      },
      set (newValue) {
        this.$emit('update:companyNameProps', newValue);
      }
    }
  },
  methods: {
    onShareLink: function () {
      window.open(
        `http://www.facebook.com/sharer.php?u=https://${location.host}/main/html/searchrlp/company_id/${this.companyId}`,
        'sharewindow',
        `width=550, height=450, personalbar=0, toolbar=0, scrollbars=1, resizable=!, left=${(screen.width - 550) / 2},top=${(screen.height - 450) / 2}`
      );

      this.closeModal();
    },
    closeModal: function () {
      this.$emit('closeModal');
    }
  }
};
</script>
